// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pbutton{background-color:var(--button-color);color:var(--light-text-color);border:none;padding-top:0;padding-bottom:20px;min-width:120px;height:25px;font-size:medium;margin:10px;text-decoration:none}@media screen and (min-width:812px){.image{margin:10px;max-width:90%;height:auto}}@media screen and (max-width:812px){.image{margin:10px;width:auto;max-height:250px}}", ""]);
// Exports
module.exports = exports;
